import * as React from "react"
import { format } from "date-fns"
import { bg } from "date-fns/locale"
import { CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

function DatePicker({ value, onChange, placeholder = "Изберете дата", className }) {
  const [open, setOpen] = React.useState(false)
  
  // Convert string date to Date object
  const dateValue = value ? new Date(value + "T00:00:00") : undefined
  
  const handleSelect = (date) => {
    if (date) {
      // Format as YYYY-MM-DD for backend compatibility
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      onChange(`${year}-${month}-${day}`)
    } else {
      onChange('')
    }
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "w-full justify-start text-left font-normal h-10 border-2",
            !value && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {dateValue ? format(dateValue, "dd.MM.yyyy", { locale: bg }) : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={dateValue}
          onSelect={handleSelect}
          locale={bg}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
}

export { DatePicker }
